import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M73.3699 18.48L31.5899 1.46997C31.5899 1.46997 11.5499 5.12998 5.16986 6.41998C5.16986 6.41998 -0.610146 9.05998 1.53985 17.98C3.68985 26.9 4.67989 31.19 2.19989 33.83C2.19989 33.83 5.49985 36.14 9.46985 34.66C9.46985 34.66 7.03986 40.36 7.97986 46.05C9.13986 52.99 14.5299 54.13 13.9799 57.77C13.9799 57.77 21.4599 57.77 24.7799 51.08C24.7799 51.08 30.4899 58.84 40.9999 61.25C52.5599 63.89 62.4699 60.09 66.0999 57.95C69.0299 56.22 70.8899 56.46 72.0399 58.94C72.0399 58.94 76.8099 56.72 78.6499 50.35C82.6199 36.65 73.3699 18.48 73.3699 18.48Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
